export const pieceColors = ["WHITE", "BLACK"];
export const pieceTypes = ["REGULAR", "KING"];
